import { createAsyncThunk } from '@reduxjs/toolkit';
import { getMapViewFilteredPoints,  getAnalogueMapViewFilteredPoints} from "api/mapView/service";
import { CancelTokenSource } from 'axios';
import { requestDeduplicationService } from 'helpers/functions/requestDeduplication';

export const getFullMapViewThunk = createAsyncThunk('mapView/getFullMapData', async (data: {
    workspaceId: string,
    source?: CancelTokenSource
}, thunkAPI) => {    
    const requestConfig = {
        url: `/Workspace/${data.workspaceId}/MapView/Data`,
        method: 'GET',
        params: { ApplyFilters: false }
    };

    const response = await requestDeduplicationService.executeRequest(
        requestConfig,
        () => getMapViewFilteredPoints({...data, ApplyFilters: false, source: data.source}, thunkAPI)
    );
    
    return response
});

export const getMapViewFilteredPointsThunk = createAsyncThunk('mapView/getFilteredPoints', async (data: {
    workspaceId: string,
    source?: CancelTokenSource
}, thunkAPI) => {    
    const requestConfig = {
        url: `/Workspace/${data.workspaceId}/MapView/Data`,
        method: 'GET',
        params: { 
            ApplyFilters: true,
            ...(data.source && { cancelToken: data.source.token })
        }
    };

    const response = await requestDeduplicationService.executeRequest(
        requestConfig,
        () => getMapViewFilteredPoints(data, thunkAPI)
    );
    
    return response
});

export const getAnalogueMapViewFilteredPointsThunk = createAsyncThunk('mapView/getAnalogueFilteredPoints', async (data: {
    plotId: string,
    source?: CancelTokenSource
}, thunkAPI) => {    
    const requestConfig = {
        url: `/Workspace/${data.plotId}/AnalogueMapView/Data`,
        method: 'GET',
        params: { 
            ApplyFilters: true,
            ...(data.source && { cancelToken: data.source.token })
        }
    };

    const response = await requestDeduplicationService.executeRequest(
        requestConfig,
        () => getAnalogueMapViewFilteredPoints(data, thunkAPI)
    );
    
    return response
});

export const getMapViewPolygonsThunk = createAsyncThunk('mapView/getPolygons', async (data: {
    workspaceId: string,
    title?: string
    ApplyFilters?: boolean
    leftBottomCorner?: {
        latitude: number,
        longitude: number
    },
    rightTopCorner?: {
        latitude: number,
        longitude: number
    }
}, thunkAPI) => {    
    const response = await getMapViewFilteredPoints(data, thunkAPI)
    return response
});